<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Buat Kontak Baru</h1>
          </div>
        <div class="section-body">
            <h2 class="section-title">Buat Kontak</h2>
            <div class="row">
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Kontak</h4>
                        </div>
                        <div class="card-body" style="min-height:450px;">
                            <div class="form-group">
                                <label>Tipe Kontak *</label>
                                <select id="tipe" v-model="tipe_kontak" class="form-control">
                                    <option value="customer">Pelanggan</option>
                                    <option value="supplier">Supplier</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Nama Kontak *</label>
                                <input type="text" v-model="display_name" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Email Kontak</label>
                                <input type="email" v-model="email" class="form-control">
                            </div>
                            <div class="form-group">
                                <span style="color:red;">* = Wajib diisi</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="card">
                        <div class="card-header">
                            <h4>Detail Kontak</h4>
                        </div>
                        <div class="card-body" style="min-height:450px;">
                            <div class="form-group">
                                <label>Nama Perusahaan</label>
                                <input type="text" v-model="nama_perusahaan" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Nama Pemilik</label>
                                <input type="text" v-model="nama_pemilik" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Alamat Perusahaan</label>
                                <textarea class="form-control" v-model="alamat_perusahaan"></textarea>
                            </div>
                            <div class="form-group">
                                <label>Nomor Telepon</label>
                                <input type="text" v-model="nomor_telepon" class="form-control">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <button @click="goBack()" class="btn btn-danger"><i class="fas fa-times"></i> Batal</button>
                    <button v-if="type == 'new'" @click="submit('normal')" class="btn btn-success">Buat Kontak</button>
                    <button v-if="type == 'edit'" @click="submit('edit')" class="btn btn-success">Edit Kontak</button>
                    <button v-if="type == 'new'" @click="submit('next')" class="btn btn-primary">Buat & Baru</button>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>
<script>
export default {
    data() {
        return {
            tipe_kontak : '',
            display_name : '',
            email : '',
            nama_perusahaan : '',
            nama_pemilik : '',
            alamat_perusahaan : '',
            nomor_telepon : '',
            type : 'new',
            id_kontak : '',
            kontakDetail : []
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init: function() {
            // get Kontak detail
            if(this.$route.params.id_kontak != null) {
                this.type = 'edit'
                this.id_kontak = this.$route.params.id_kontak
                this.$http.post("Kontak/getKontakDetail/"+this.id_kontak).then(result => {
                    if(result.data.code == '00') {
                        alert('failed get Detail')
                    }
                    else {
                        this.kontakDetail = result.data.detail
                        this.tipe_kontak = this.kontakDetail.detail.tipe_kontak
                        this.display_name = this.kontakDetail.detail.display_name
                        this.email = this.kontakDetail.detail.email
                        this.nama_perusahaan  = this.kontakDetail.detail.company_name
                        this.nama_pemilik = this.kontakDetail.detail.nama_pemilik
                        this.alamat_perusahaan = this.kontakDetail.detail.alamat
                        this.nomor_telepon = this.kontakDetail.detail.nomor_tlp
                    }
                }, error => {
                    console.log('gk ok')
                    context.errors = errors;
                });
            }
        },
        goBack: function() {
            this.$router.replace({ path : window.localStorage.getItem('last_route') })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
        submit: function(type) {
            if(this.tipe_kontak == '' || this.display_name == '') {
                this.$parent.toastr = {
                    title : 'Warning',
                    message : 'Tipe Kontak dan Nama Kontak Wajib Diisi !',
                    type : 'warning'
                }
                return false
            }

            var formsub = new FormData();
            formsub.append('type',this.type)
            if(this.type == 'edit') {
                formsub.append('id_kontak',this.id_kontak)
            }
            formsub.append('tipe_kontak',this.tipe_kontak);
            formsub.append('display_name',this.display_name);
            formsub.append('email', this.email);
            formsub.append('nama_perusahaan',this.nama_perusahaan);
            formsub.append('nama_pemilik',this.nama_pemilik);
            formsub.append('alamat_perusahaan',this.alamat_perusahaan);
            formsub.append('nomor_telepon',this.nomor_telepon)
            
            this.$http.post("Kontak/updateKontak", formsub).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Kontak berhasil diinput / diupdate !',
                        type : 'success'
                    }
                    if(type == 'normal'){
                        this.$router.replace({ path : window.localStorage.getItem('last_route') })
                    }else if(type == 'next'){
                        this.$router.replace({ path : '/master/kontak/kontak-baru' })
                    }else {
                        this.init();
                    }
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Kontak gagal diinput !',
                        type : 'error'
                    }                    
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
			});
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/kontak/KontakBaru.vue